export const locales = {
	groupLabel: 'Filtres'
};
